<style lang="less">
	.v-tabs-slider{
		background: transparent !important;
	}
</style>

<template>
		<v-tabs right class="d-sm-block" show-arrows color="black" v-model="tab">
			<v-tab class="font-weight-thin" @click="doScroll('#howItWorks')">How It Works</v-tab>
			<v-tab class="font-weight-thin" @click="doScroll('#about')">About Us</v-tab>
			<v-tab class="font-weight-thin" @click="doScroll('#recentStudies')">Recent Studies</v-tab>
			<v-tab class="font-weight-thin" @click="doScroll('#contact')">Contact</v-tab>
		</v-tabs>

</template>


<script>
	export default {
		name: "NavigationTop", 
		data: () => {
			return {
				tab: null,
				options: {

				}
			}
		}, 
		methods: {
			doScroll(target){
				if( this.$route.name == "Home") {
					this.$vuetify.goTo(target, this.options);
				}
				else{
					this.$router.push("/" ).then( () => {
						this.$vuetify.goTo(target, this.options);
					});
				}
			}
		}
	}
</script>

